import { kk as reactkk } from '@ews/react-translations';

const kk = {
...reactkk
}
export default kk
